import { render, staticRenderFns } from "./Selfdisclosure.vue?vue&type=template&id=7432811d&"
import script from "./Selfdisclosure.vue?vue&type=script&lang=js&"
export * from "./Selfdisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports